<nz-form-item>
  <div style="padding: 6px">
    @if (title) {
    <span>{{ title }}</span>
    }
  </div>
  <div class="tw-flex">
    <div>
      <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
        <nz-switch ngDefaultControl [class]="inputClass" [formControl]="asFormControl(inputFormControl)"></nz-switch>
        <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
      </nz-form-control>
    </div>
    @if (label) {
    <div style="margin-left: 5px">
      {{ label }}
    </div>
    }
  </div>
</nz-form-item>
